import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 150 150" fill="none">
    {props.children}
    <path
      fill="none"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m70.7 62.8-37-21.6-.2-38.8 37.2 21.9v38.5Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M147.2 101.5 75.2 60 2.9 101.7l72 41.5 72.3-41.7Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.86 6.86"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M147 108 75 66.8 2.8 108.3l71.8 41.4 72.4-41.6Z"
    />
    <path
      fill="none"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m121.5 104.2-24.3-14V64.8L121.6 79v25Z"
    />
    <path fill="#F4EEE6" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m36 101 7 4-7.7 4.5-7-4L36 101Z" />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m45.7 106.3 15.4 9.1-7.9 4.7-15.4-9.2 7.9-4.6ZM61.1 120l16 9.6"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m105.7 27.8 21 12.3.1 6.8-21.2-12.4v-6.7Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m102.3 110-42-24.2a18.1 18.1 0 0 0-16.4 0c-4.6 2.6-4.6 6.8 0 9.4l42 24.3a18.1 18.1 0 0 0 16.4 0c4.5-2.6 4.5-6.9 0-9.5Z"
    />
    <path fill="#fefdfc" d="M105.1 51.3v64.9l-4.2 3.9-7.7 1.3-6-1.4-45.4-26.5-1.6-2.2V27.5l23-.8 42 24.6Z" />
    <path
      fill="#F4EEE6"
      d="M73.9 72.2c0-3.4-2.4-7.5-5.4-9.2-3-1.7-5.3-.4-5.3 3a12 12 0 0 0 3.6 8v12l3.2 1.8v-12c2.3.6 3.9-.8 3.9-3.6Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M70.4 73.6c0-3.4-2.4-7.6-5.3-9.3s-5.3-.3-5.3 3.1a12 12 0 0 0 3.6 8v11.9l3.2 1.9v-12c2.2.6 3.8-.8 3.8-3.6Z"
    />
    <path
      fill="#F4EEE6"
      d="m90.8 60.2.7 52c0 1-.4 2-1 2.8a4.6 4.6 0 0 1-4.5 1.6h-.1c-3.9-.8-9.2-2.4-12.7-4.4l13.4 8 3.8 1 4.3.5 8.1-2.5 2.4-2.6.5-1.4V55l-1.7 2.6-5.3 2.7-4.7.4-3.2-.4Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m102.3 49-42-24.2c-4.6-2.6-11.9-2.6-16.4 0s-4.6 6.9 0 9.5l42 24.2c4.5 2.6 11.9 2.6 16.4 0s4.5-6.8 0-9.4ZM40.5 29.8v61.5m65.2 23.9c-.2 1.6-1.3 3-3.4 4.3a18.1 18.1 0 0 1-16.4 0L44 95.2c-2.2-1.2-3.3-2.8-3.4-4.5"
    />
    <path
      fill="#fff"
      d="M64.2 30.6c0 1.7-2.3 3-5.2 3s-5.1-1.3-5.1-3V16c0-6.3 2.5-11.5 6.9-14s10-2.2 15.6 1a37.9 37.9 0 0 1 17.3 30v14.7c0 1.6-2.3 3-5.1 3s-5.2-1.3-5.2-3V33c0-7.6-5.6-17.3-12.1-21-2.2-1.4-4.2-1.7-5.3-1.1-1 .6-1.8 2.5-1.8 5v14.8Z"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M105.7 54.3v60.5" />
    <path
      fill="#fefdfc"
      d="M90 22.5c.2 0 .2-.1.3-.2A36.4 36.4 0 0 0 75.9 4C70.8 1 65.5.6 61.4 3c-4 2.4-6.4 7.3-6.4 13.4v2.4s1.5-9.2 9.5-12c7.9-2.7 13.9 5 17 10.1 3.1 5.1 5.6 7.2 8.6 5.6Z"
    />
    <path
      fill="#F4EEE6"
      d="M59.6 18.8c0-1.6.4-3.1 1.2-4.5a7.3 7.3 0 0 1 3.6-3l2-.8-1.5 2-.7 2.8-.2 16.3-1.7 1.4-2.7.7V18.8Zm29.6 31.7V33.2a7.9 7.9 0 0 1 3.6-6.6l1 3.2v18.5l-1.4 1.6-3.2.8v-.2Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M93.7 33v14.7M64.2 30.6c0 1.7-2.3 3-5.2 3s-5.1-1.3-5.1-3V16c0-6.3 2.5-11.5 6.9-14s10-2.2 15.6 1a37.9 37.9 0 0 1 17.3 30v14.7c0 1.6-2.3 3-5.1 3s-5.2-1.3-5.2-3V33c0-7.6-5.6-17.3-12.1-21-2.2-1.4-4.2-1.7-5.3-1.1-1 .6-1.8 2.5-1.8 5v14.8Z"
    />
  </svg>
);
